import React, { useState } from "react";

export default function Pricing() {
	const [activeCard, setActiveCard] = useState(null);

	const pricingData = [
		{
			id: 1,
			name: "LOGO",
			price: 4000,
			features: ["Vector Files", "2 Revisions Free", "Trendy Design"],
		},
		{
			id: 2,
			name: "LOGO + BUSINESS CARD",
			price: 5000,
			features: [
				"Complete Brand Package",
				"3 Revisions Free",
				"Premium Design",
			],
			popular: true,
		},
		{
			id: 3,
			name: "BUSINESS CARD",
			price: 3000,
			features: [
				"Double-sided Design",
				"Print-ready Files",
				"Modern Design",
			],
		},
		{
			id: 4,
			name: "FLYER",
			price: 3000,
			features: [
				"Super High Resolution",
				"Print-ready Files",
				"Custom Modern Design",
			],
		},
	];

	return (
		<div className="min-h-screen bg-gradient-to-b from-purple-50 to-pink-50 py-20 relative overflow-hidden">
			<div className="container mx-auto px-4 relative z-10">
				<h2 className="text-6xl font-black text-center mb-20">
					<span className="bg-gradient-to-r from-purple-600 via-pink-500 to-purple-600 bg-clip-text text-transparent">
						Choose Your Package
					</span>
				</h2>

				<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
					{pricingData.map((plan) => (
						<div
							key={plan.id}
							className={`transform transition-all duration-500 ${
								activeCard === plan.id
									? "scale-105"
									: "hover:scale-102"
							}`}
							onMouseEnter={() => setActiveCard(plan.id)}
							onMouseLeave={() => setActiveCard(null)}
						>
							<div
								className={`
                bg-white/80 backdrop-blur-xl
                shadow-lg shadow-purple-100
                rounded-3xl p-8 h-[450px]
                relative overflow-hidden
                ${
					plan.popular
						? "ring-2 ring-pink-500 ring-offset-4 ring-offset-purple-50"
						: ""
				}
              `}
							>
								<div className="absolute inset-0 bg-gradient-to-br from-purple-100/50 to-pink-100/50 pointer-events-none" />

								{plan.popular && (
									<div className="absolute -top-1 -right-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white text-sm font-bold px-8 py-1 rounded-bl-xl transform">
										POPULAR
									</div>
								)}

								<div className="relative z-10">
									<h3 className="text-2xl font-bold text-purple-900 mb-4">
										{plan.name}
									</h3>
									<div className="text-5xl font-black mb-8 text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-500">
										₹{plan.price}
									</div>

									<div className="space-y-4">
										{plan.features.map((feature, index) => (
											<div
												key={index}
												className="flex items-center text-purple-800"
											>
												<span className="w-2 h-2 bg-pink-400 rounded-full mr-3" />
												{feature}
											</div>
										))}
									</div>

									<button className="mt-8 w-full bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white py-4 rounded-xl font-bold transform transition-all hover:scale-105">
										Select Package
									</button>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}
